import { tools } from '@halo/ui-chat-react';

interface ExpireMessageIconProps {
  value: number;
}

const ExpireMessageIcon = ({ value }: ExpireMessageIconProps) => {
  const [num, unit] = (value && tools.expireTimeOptions.findByValue(value)?.text) || [];

  if (!value) {
    return null;
  }

  return (
    <svg
      width="1.857em"
      height="1.857em"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 20C16.6421 20 20 16.6421 20 12.5C20 8.35786 16.6421 5 12.5 5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeDasharray="2.31 2.31"
      />
      <path
        d="M12.5 20C8.35786 20 5 16.6421 5 12.5C5 8.35786 8.35786 5 12.5 5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <text
        x="12"
        y="16"
        style={{
          fill: 'currentColor',
          textAnchor: 'middle',
          fontWeight: '500',
          fontFamily: 'manrope',
        }}
      >
        <tspan>
          <tspan style={{ fontSize: '10px' }}>{num}</tspan>
          <tspan style={{ fontSize: '8px' }}>{unit}</tspan>
        </tspan>
      </text>
    </svg>
  );
};
const ExpireMessageIconLine = ({ value }: ExpireMessageIconProps) => {
  const [num, unit] =
    (value !== undefined && value !== null && tools.expireTimeOptions.findByValue(value)?.text) ||
    [];
  if (value === undefined || value === null) {
    return null;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g>
        <text
          x="8"
          y="13"
          style={{
            fill: 'currentColor',
            textAnchor: 'middle',
            fontWeight: '500',
            fontSize: '10px',
            fontFamily: 'manrope',
          }}
        >
          {num}
        </text>
        {num === 'N' ? (
          <>
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M13.0547 14.4991C13.7374 13.9302 14.2205 13.2668 14.5547 12.5781"
              stroke="currentColor"
              strokeLinecap="round"
            />
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M15.0904 8C15.2704 8.71995 15.3297 9.68329 15.0078 11"
              stroke="currentColor"
              strokeLinecap="round"
            />
          </>
        ) : (
          <text
            x="15"
            y="14"
            style={{
              fill: 'currentColor',
              textAnchor: 'middle',
              fontWeight: '500',
              fontSize: '8px',
              fontFamily: 'manrope',
            }}
          >
            {unit}
          </text>
        )}

        <path
          d="M12.1859 15.2154C11.0177 15.9973 9.61296 16.4533 8.10167 16.4533C4.04145 16.4533 0.75 13.1619 0.75 9.10167C0.75 5.04145 4.04145 1.75 8.10167 1.75C11.3131 1.75 14.0437 3.80922 15.0449 6.6793"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

const MemoExpireMessageIcon = memo(ExpireMessageIcon);
const MemoExpireMessageIconLine = memo(ExpireMessageIconLine);

export {
  MemoExpireMessageIcon as ExpireMessageIcon,
  MemoExpireMessageIconLine as ExpireMessageIconLine,
};
